import React from 'react';
import { Box, Grid } from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Loader } from '../Loader';

const StudentSkeleton = () => (
  <Box sx={{ mt: 2 }}>
    <Loader />
    <Grid container spacing={2}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Skeleton />
        </Grid>
        <Grid item xs={6}>
          <Skeleton count={3} />
        </Grid>
        <Grid item xs={6}>
          <Skeleton count={3} />
        </Grid>
      </Grid>
    </Grid>
  </Box>
);

export { StudentSkeleton };
